import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFrontView = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_1233_16381",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_1233_16381)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M18.5996 18.7V5.30005H19.8996V18.7H18.5996ZM11.9996 16.4538L11.0709 15.5251L13.9459 12.65H4.09961V11.35H13.9459L11.0709 8.47505L11.9996 7.5463L16.4534 12L11.9996 16.4538Z",
			fill: "currentColor"
		})
	})]
});
export default SvgFrontView;
